"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toml_1 = require("@iarna/toml");
var Quality;
(function (Quality) {
    Quality["HIGH"] = "HIGH";
    Quality["MEDIUM_OR_LOW"] = "MEDIUM_OR_LOW";
})(Quality || (Quality = {}));
class StellarCoreConfigurationGenerator {
    constructor(network) {
        this.network = network;
    }
    quorumSetToToml(quorumSet) {
        let alreadyAddedHomeDomains = new Set();
        let tomlConfig = {
            HOME_DOMAINS: [],
            VALIDATORS: []
        };
        this.processQuorumSet(quorumSet, tomlConfig, alreadyAddedHomeDomains);
        //@ts-ignore library doesn't handle undefined values correctly
        return toml_1.stringify(tomlConfig);
    }
    nodesToToml(nodes) {
        let alreadyAddedHomeDomains = new Set();
        let tomlConfig = {
            HOME_DOMAINS: [],
            VALIDATORS: []
        };
        nodes.forEach(node => this.processValidator(node, alreadyAddedHomeDomains, tomlConfig));
        //@ts-ignore library doesn't handle undefined values correctly
        return toml_1.stringify(tomlConfig);
    }
    processQuorumSet(quorumSet, tomlConfig, alreadyAddedHomeDomains = new Set()) {
        quorumSet.validators.forEach(validator => this.processValidator(this.network.getNodeByPublicKey(validator), alreadyAddedHomeDomains, tomlConfig));
        quorumSet.innerQuorumSets.forEach(innerQSet => this.processQuorumSet(innerQSet, tomlConfig, alreadyAddedHomeDomains));
    }
    processValidator(validatorNode, alreadyAddedHomeDomains, tomlConfig) {
        let validatorToml = {
            NAME: validatorNode.displayName,
            PUBLIC_KEY: validatorNode.publicKey,
            ADDRESS: validatorNode.key,
        };
        if (validatorNode.historyUrl)
            validatorToml.HISTORY = `curl -sf ${validatorNode.historyUrl} -o {1}`;
        if (validatorNode.homeDomain) {
            let quality = Quality.MEDIUM_OR_LOW;
            if (validatorNode.organizationId) {
                let organization = this.network.getOrganizationById(validatorNode.organizationId);
                if (organization.isTierOneOrganization)
                    quality = Quality.HIGH;
            }
            if (!alreadyAddedHomeDomains.has(validatorNode.homeDomain)) {
                alreadyAddedHomeDomains.add(validatorNode.homeDomain);
                tomlConfig.HOME_DOMAINS.push({
                    HOME_DOMAIN: validatorNode.homeDomain,
                    QUALITY: quality
                });
            }
            validatorToml.HOME_DOMAIN = validatorNode.homeDomain;
        }
        else {
            validatorToml.QUALITY = Quality.MEDIUM_OR_LOW;
        }
        tomlConfig.VALIDATORS.push(validatorToml);
    }
}
exports.default = StellarCoreConfigurationGenerator;
//# sourceMappingURL=stellar-core-configuration-generator.js.map